import React from 'react';
import classNames from 'classnames';

import { awardsData } from '@store/TestingData';
import { PaddingContainer } from '@components';
import { AwardsProps } from './AwardsProps';

import * as styles from './Awards.module.scss';

export const Awards: React.FC<AwardsProps> = ({
	className,
	title = 'Auszeichnungen',
	subtitle,
	subtitleClassName,
	awardsGridClassName,
	awardTitleOnRight = false,
}) => {
	return (
		<PaddingContainer className={classNames('white-bg', className)}>
			<div className={styles.awardsContainer}>
				<div className="mb-5">
					<h2 className="font-size-medium-title ">{title}</h2>
					{subtitle && (
						<p className={classNames(subtitleClassName, 'font-size-sm')}>
							{subtitle}
						</p>
					)}
				</div>
				<div
					className={classNames(
						awardsGridClassName,
						styles.awardGrid,
						'row no-gutters'
					)}
				>
					{awardsData.map((item, index) => (
						<div
							className={classNames(
								'col-12 col-sm-6 col-xl-3 d-flex align-items-center my-3',
								!awardTitleOnRight
									? 'justify-content-center'
									: 'justify-content-start'
							)}
							key={item.name + index}
						>
							<div
								className={classNames(
									styles.award,
									!awardTitleOnRight && 'flex-column',
									'd-flex align-items-center justify-content-center'
								)}
							>
								<div
									className={classNames(
										styles.awardImage,
										awardTitleOnRight && styles.awardTitleOnRight,
										'd-flex justify-content-center'
									)}
								>
									{item.icon}
								</div>
								<div
									className={classNames(
										!awardTitleOnRight ? 'mt-3 text-center' : 'pl-3 text-left',
										'uppercase font-size-14 text-left'
									)}
								>
									{item.name}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</PaddingContainer>
	);
};
